import log from 'loglevel';

export default defineNuxtPlugin(() => {
    if (import.meta.env.MODE === 'development' || import.meta.env.VITE_DEPLOYMENT_MODE === 'development') {
        log.setLevel('debug');
        log.info('Log enabled');
    } else {
        log.setLevel('silent');
    }

    return {
        provide: {
            log,
        },
    };
});
